<template>
    <div class="content">
        <div class="work-list">
            <WorksArea :on-work-load-page="onWorkLoadPage"
                       show-name
                       :default-list="props.works.data"
                       :default-page="2">
                <template #no-data>
                    没有收藏的作品
                </template>
            </WorksArea>
        </div>
    </div>
</template>

<script setup lang="ts">
import UserShowLayout from "@/Components/Layout/UserShowLayout.vue";
import WorksArea from "@/Components/Work/WorksArea.vue";
import http from "@/utils/http";

const props = defineProps<{
    works: any
}>()

const onWorkLoadPage = async (page: number) => {
    const res = await http.get(location.href, {
        params: {
            page,
        }
    })
    return res.data.works.data
}

defineOptions({
    layout: UserShowLayout
})
</script>

<style scoped lang="less">
.work-list {
    margin-top: 30px;
}
</style>
